export var createQueuesApi = function (baseUrl, http) {
    var url = baseUrl + "/queues";
    return {
        getQueue: function (queueId) {
            return http.get(url + "/" + queueId);
        },
        getQueues: function () {
            return http.get("" + url);
        },
        getStats: function () {
            return http.get(url + "/stats");
        },
        deleteQueue: function (queueId) {
            return http.delete(url + "/" + queueId);
        },
        getAssignedAgents: function (queueId) {
            return http.get(url + "/" + queueId + "/agents");
        },
        assignAgentToQueue: function (dto) {
            return http.post(url + "/" + dto.queueId + "/agents/" + dto.agentId, {});
        },
        removeAgentFromQueue: function (dto) {
            return http.delete(url + "/" + dto.queueId + "/agents/" + dto.agentId);
        },
        updateQueueWaitOfferOptions: function (dto) {
            return http.put(url + "/" + dto.queueId + "/queueWaitOfferOptions", dto.queueWaitOfferSettings);
        },
        updateWaitOfferOptions: function (dto) {
            return http.put(url + "/" + dto.queueId + "/settings/waitOffers", dto.waitOfferSettings);
        },
        updateOpeningHoursSettings: function (dto) {
            return http.put(url + "/" + dto.queueId + "/settings/openingHours", dto.openingHoursSettings);
        },
        updateQueueNonAvailableAgentsSettings: function (dto) {
            return http.put(url + "/" + dto.queueId + "/settings/nonAvailableAgents", dto.queueNonAvailableAgentsSettings);
        },
        updateCallOptions: function (dto) {
            return http.put(url + "/" + dto.queueId + "/callOptions", dto.callOptions);
        },
        enableGlobalCallOptions: function (queueId) {
            return http.put(url + "/" + queueId + "/globalCallOptions/enable", {});
        },
        disableGlobalCallOptions: function (queueId) {
            return http.put(url + "/" + queueId + "/globalCallOptions/disable", {});
        },
        manualTransferBlock: function (dto) {
            var state = dto.enabled ? 'enable' : 'disable';
            return http.put(url + "/" + dto.queueId + "/callTransferBlock/" + state, {});
        },
    };
};
//# sourceMappingURL=index.js.map